import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { ListRolesFacade } from '../../../../../Facades/list-roles.facade';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { RolesTableComponent } from '../../Partials/roles-table/roles-table.component';
import { Subject } from 'rxjs';
import { AuthService } from '../../../../Shared/Services/auth.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { PERMISSIONS } from '../../../../../Enums/permission.enum';

@Component({
  selector: 'app-roles-management',
  imports: [COMMON_IMPORTS, RolesTableComponent],
  templateUrl: './roles-management.component.html',
  styleUrls: ['./roles-management.component.scss', '../../../../../../assets/theme/cutom/_error-container.scss'],
})
export class RolesManagementComponent{
  readonly facade = inject(ListRolesFacade);
  private readonly _authService = inject(AuthService);
  private readonly destroy$ = new Subject<void>();
  
  searchControl = new FormControl<string>('');
  permissions = PERMISSIONS;

  readonly currentUser = toSignal(this._authService.currentUser$, { initialValue: null });

  constructor() {
    this.initSearch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initSearch(): void {
    this.searchControl
      .valueChanges.pipe(
        debounceTime(500),
        filter((value: string | null) => value !== null && (value.length === 0 || value.length >= 2)),
        takeUntil(this.destroy$)
      )
      .subscribe((value: string | null) => {
        this.facade.setSearchTerm(value ?? '');
      });
  }
}
